import React from "react";
import { PaymentMethodType } from "./types";

type PaymentMethodToggleProps = {
  selected: PaymentMethodType;
  onChange: (method: PaymentMethodType) => void;
};

const PaymentMethodToggle: React.FC<PaymentMethodToggleProps> = ({
  selected,
  onChange,
}) => {
  return (
    <div className="mb-6 flex justify-center space-x-4">
      <button
        type="button"
        onClick={() => onChange("bank")}
        className={`rounded px-4 py-2 transition-colors ${
          selected === "bank"
            ? "bg-cantelope text-soil"
            : "bg-gray-100 text-gray-700 hover:bg-gray-200"
        }`}
      >
        Bank Account
      </button>
      <button
        type="button"
        onClick={() => onChange("card")}
        className={`rounded px-4 py-2 transition-colors ${
          selected === "card"
            ? "bg-cantelope text-soil"
            : "bg-gray-100 text-gray-700 hover:bg-gray-200"
        }`}
      >
        Credit Card
      </button>
    </div>
  );
};

export default PaymentMethodToggle;
